import React, { useContext } from 'react';
import ProjectListCard from '@nile/projects/src/Pages/ProjectListCard';
import ProjectListTableContainer from '@nile/projects/src/Containers/ProjectListTableContainer';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { SkeletonTableLoading } from '@nile/components';

const ProjectListContainer = (props) => {
  const { allEntities, projectViews, projectViewMeta } = props;

  const context = useContext(TicketContext);
  const { projectViewType ,viewTypeLoading} = context;


  if (viewTypeLoading) return <SkeletonTableLoading />;
  
  if (projectViewType === 'list') {
    return (
      <ProjectListTableContainer
        projectViews={projectViews}
        projectViewMeta={projectViewMeta}
      />
    );
  }

  return (
    <ProjectListCard allEntities={allEntities} projectViews={projectViews} />
  );
};

export default ProjectListContainer;
